// One card per sub-feature of the PRD.
//
// Each card carries its PRD reference, because the point of this surface is to
// be checked against that document. A card that cannot run says which kind of
// cannot — needing Brand Registry and needing collection send the seller to
// different places, and one shared empty state sends them nowhere.
import React from 'react';
import { FiArrowRight, FiLock, FiSlash } from 'react-icons/fi';
import s from '../Visibility.module.css';

export default function FeatureCards({ data, loading, onOpen }) {
  if (loading && !data) {
    return (
      <div className={s.cardGrid}>
        {[0, 1, 2, 3, 4].map((i) => <div key={i} className={s.cardSkeleton} />)}
      </div>
    );
  }
  if (!data?.cards?.length) return null;

  return (
    <div className={s.cardGrid}>
      {data.cards.map((card) => {
        // SF6 is closed, not merely empty — it can never open.
        const closed = card.key === 'competitor';
        const clickable = !closed && card.state === 'found' && card.key !== 'page_views';
        return (
          <section key={card.key}
                   className={`${s.card} ${s[`card_${card.state}`]} ${clickable ? s.cardOpen : ''}`}
                   onClick={clickable ? () => onOpen(card.key) : undefined}
                   role={clickable ? 'button' : undefined}
                   tabIndex={clickable ? 0 : undefined}
                   onKeyDown={clickable ? (e) => {
                     if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(card.key); }
                   } : undefined}>
            <header className={s.cardHead}>
              <span className={s.cardRef}>{card.ref}</span>
              {clickable && <FiArrowRight className={s.cardGo} />}
              {closed && <FiSlash className={s.cardLock} />}
              {!closed && card.state === 'unavailable' && <FiLock className={s.cardLock} />}
            </header>
            <h3 className={s.cardTitle}>{card.title}</h3>
            <p className={s.cardQuestion}>{card.question}</p>

            <div className={s.cardHeadline}>
              <span className={s.cardValue}>{card.headline}</span>
              {card.unit && <span className={s.cardUnit}>{card.unit}</span>}
            </div>
            <p className={s.cardDetail}>{card.detail}</p>
          </section>
        );
      })}
    </div>
  );
}
